export default __webpack_public_path__ + "static/media/IMG_2205.48c3d379.JPG";